import { isSystem, lang } from '@umu/ukit-lang';
import { IAppNavigationItemIcon } from '../interface/interface';
import { IIconInfo, IMAGE_TYPE } from '../interface';
import { EMediaType } from '@umu/umu-types';

import { DEFAULT_CUSTOM_ICON_COLOR, DEFAULT_ICON_COLOR, DEFAULT_NORMAL_ICON_COLOR } from '../dataFlow';
import { getCharacterLength } from '../../../@utils';
import { getUploadResult } from '../../../services';
interface IAppNavigationLangInfo {
    title: string;
    desc?: string;
    key: string;
}
const defaultWhiteOverlayInnerStyle = {
    background: '#ffffff',
    color: '#222222',
    fontSize: '0.14rem',
    lineHeight: '0.2rem',
    padding: '0.12rem',
};
const getNavIcon = (
    value: IAppNavigationItemIcon,
    config: { isHideNormalIcon: boolean; isForceSvgToImg?: boolean },
    // showImg表示强制将svg展示为图片
): IIconInfo => {
    const { isHideNormalIcon, isForceSvgToImg = false } = config;
    const isCustom = Object(value).hasOwnProperty('custom') || isForceSvgToImg;
    const { svg } = value;
    const custom = isCustom && isForceSvgToImg ? svg || value.custom : value.custom;
    const iconName = svg?.icon_name || 'AppletsProfileBorderBox';
    const defaultIconNormalColor = svg?.normal_color || DEFAULT_NORMAL_ICON_COLOR;
    const defaultColor = isHideNormalIcon ? DEFAULT_CUSTOM_ICON_COLOR : DEFAULT_ICON_COLOR;
    return {
        iconType: isCustom ? IMAGE_TYPE.CUSTOM : IMAGE_TYPE.SVG,
        iconName,
        activeIconName: isHideNormalIcon ? iconName : `${iconName}Active`,
        normalIcon: custom?.normal_url || '',
        activeIcon: custom?.selected_url || '',
        svgUrl: svg?.normal_url || '',
        activeSvgUrl: svg?.selected_url || '',
        normalColor: defaultIconNormalColor,
        color: svg?.selected_color || defaultColor,
    };
};
const onUploadImg = async (blob: Blob, teacherId: string = '') => {
    const previewUrl = window.URL.createObjectURL(blob);

    const param = {
        blob,
        ext: 'png',
        previewUrl,
        fileName: '',
        mediaType: EMediaType.IMAGE,
        teacherId,
    };
    const urls = await getUploadResult(param);
    return urls.url;
};

const onChooseFile = (ev: React.ChangeEvent<HTMLInputElement>, callBack: (urls: string) => void) => {
    const fileList = ev.target.files;
    if (!fileList || !fileList.length) {
        return;
    }
    const files = Array.from(fileList);
    const reader = new FileReader();
    reader.readAsArrayBuffer(files[0]);

    reader.onload = async (e) => {
        if (e.target && e.target.result) {
            callBack(await onUploadImg(new Blob([e.target.result])));
        }
    };
    ev.target.value = '';
};
const getAppNavigationLangInfo = (): [IAppNavigationLangInfo, IAppNavigationLangInfo, boolean] => {
    let title = lang('英文导航名称');
    let key = 'en-us';
    let showSecond = false;
    if (isSystem('CN')) {
        title = lang('中文导航名称');
        showSecond = true;
        key = 'zh-cn';
    }
    if (isSystem('TW')) {
        title = lang('繁体导航名称');
        showSecond = true;
        key = 'zh-tw';
    }
    if (isSystem('JP')) {
        title = lang('日语导航名称');
        showSecond = true;
        key = 'ja-jp';
    }
    return [
        {
            title,
            key,
        },
        {
            title: lang('英文导航名称'),
            desc: lang('当用户切换平台语言时，App导航将展示相应的语言。'),
            key: 'en-us',
        },
        showSecond,
    ];
};
/**
 * @desc 根据语言检测当前输入名称是否合法
 */
const doubleChartList = ['zh-cn', 'ja-jp', 'zh-tw'];
const onCheckLabelBySystem = (key: string, value: string) => {
    const newValue = (value || '').trim();
    if (!newValue) {
        return false;
    }
    const len = getCharacterLength(newValue);
    if (doubleChartList.includes(key)) {
        if (len > 20) {
            // 中文、繁体、日语最大字数
            return false;
        }
    } else {
        if (len > 25) {
            // 其他语言最大字数
            return false;
        }
    }
    return true;
};
/**
 * @desc 根据语言获取输入的最大长度
 */
const getMaxLengthBySystem = (key: string) => {
    if (doubleChartList.includes(key)) {
        return 12;
    }
    return 20;
};

export {
    getNavIcon,
    onChooseFile,
    defaultWhiteOverlayInnerStyle,
    getMaxLengthBySystem,
    onCheckLabelBySystem,
    getAppNavigationLangInfo,
};
